import { StreetTypesService } from './street-types.service'
import {
  FetchStreetTypesRequest,
  FetchStreetTypesSuccess,
  FetchStreetTypesFailure,
  FetchStreetTypeRequest,
  FetchStreetTypeSuccess,
  FetchStreetTypeFailure,
  DeleteStreetTypeRequest,
  DeleteStreetTypeSuccess,
  DeleteStreetTypeFailure,
  CreateStreetTypeRequest,
  CreateStreetTypeSuccess,
  CreateStreetTypeFailure,
  UpdateStreetTypeRequest,
  UpdateStreetTypeSuccess,
  UpdateStreetTypeFailure,
} from './street-types.actions'
import { ShowSnackbar } from './../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as StreetsTypes from './street-types.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class StreetTypesEffects {
  constructor(
    private actions: Actions,
    private streetTypesService: StreetTypesService,
    private router: Router,
  ) {}

  FetchStreetTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.FETCH_STREET_TYPES_REQUEST),
      switchMap((action: FetchStreetTypesRequest) => {
        return this.streetTypesService.fetchStreetTypes(action.payload).pipe(
          map((result) => {
            return new FetchStreetTypesSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchStreetTypesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchStreetType$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.FETCH_STREET_TYPE_REQUEST),
      switchMap((action: FetchStreetTypeRequest) => {
        return this.streetTypesService.fetchStreetType(action.id).pipe(
          map((result) => {
            return new FetchStreetTypeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchStreetTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteStreetType$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.DELETE_STREET_TYPE_REQUEST),
      switchMap((action: DeleteStreetTypeRequest) => {
        return this.streetTypesService.deleteStreetType(action.id).pipe(
          switchMap((result) => {
            return [new DeleteStreetTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteStreetTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateStreetType$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.CREATE_STREET_TYPE_REQUEST),
      switchMap((action: CreateStreetTypeRequest) => {
        return this.streetTypesService.createStreetType(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/street-types'])
            return [new CreateStreetTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateStreetTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateStreetType$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.UPDATE_STREET_TYPE_REQUEST),
      switchMap((action: UpdateStreetTypeRequest) => {
        return this.streetTypesService
          .updateStreetType(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/street-types'])
              return [
                new FetchStreetTypeRequest(action.id),
                new UpdateStreetTypeSuccess(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateStreetTypeFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
